import lodash from 'lodash'
import Axios from 'axios';

const items = JSON.parse(localStorage.getItem('shopping-cart')) || []

export default {

  namespaced: true,

  state: {
    items,
    quickBuyItem: JSON.parse(localStorage.getItem('quck-buy-item')) || null,
    size: Object.keys(items).length,
    shippingTemplates: [],
    shippingFee: 0
  },

  actions: {
    async fetchShippingTemplates({ commit, state }) {
      let resp = await Axios.get("https://erp.jibbert.com/api/v2/shipfeetemplates")
      commit('setShippingFeeTemplates', resp.data)
    },

    calcuShippingFee({ commit, state }, data) {
      Axios.post("https://erp.jibbert.com/api/v2/calcshippingfee", data).then(resp => {
        commit('setShippingFee', resp.data.shipping_fee)
      }, ()=>{
        //alert("error occured while calculate shipping fee")
      })
    },

    add({ commit, state }, { spec, number = 1, orgType }) {
      const item = lodash.find(state.items, { id: spec.id })
      if (item && item.number >= item.stock) {
        return false
      }
      commit('addToCart', { ...spec, number, orgType })
      return true
    },

    remove({ commit }, { id }) {
      commit('removeToCart', id)
    },

    updateNumber({ commit }, { id, number }) {
      commit('setCartItemNumber', { id, number })
    },

    clear({ commit }, obj) {
      if (obj) {
        commit('clearCart', {org: obj.org || false})
      } else {
        commit('clearCart', {org: false})

      }
    },

    quickBuy({ commit }, { spec, number = 1 }) {
      commit('setQuickBuy', { ...spec, number })
    },

    clearQuickBuy({ commit }) {
      commit('setQuickBuy', null)
    },

    getFlowItems({ state }) {
      return state.quickBuyItem ? [state.quickBuyItem] : state.items
    }

  },

  mutations: {
    setShippingFeeTemplates(state, data) {
      state.shippingTemplates = data.data
    },
    setShippingFee(state, data) {
      state.shippingFee = data
    },

    addToCart(state, cartItem) {
      const item = lodash.find(state.items, { id: cartItem.id })
      if (item) {
        item.number++
      } else {
        state.items.push(cartItem)
      }
      state.size = state.items.length
      localStorage.setItem('shopping-cart', JSON.stringify(state.items))
    },

    removeToCart(state, id) {
      lodash.remove(state.items, { id })
      state.size = state.items.length
      state.items = [...state.items]

      localStorage.setItem('shopping-cart', JSON.stringify(state.items))
    },

    clearCart(state, obj) {
      if (obj && obj.org) {
        state.items = state.items.filter(o => {
          return o.org_id != obj.org
        })

      } else {
        state.items = []

      }
      state.quickBuyItem = null
      state.size = 0
      localStorage.setItem('shopping-cart', JSON.stringify(state.items))
      localStorage.setItem('quck-buy-item', JSON.stringify(state.quickBuyItem))
    },

    setQuickBuy(state, cartItem) {
      state.quickBuyItem = cartItem
      localStorage.setItem('quck-buy-item', JSON.stringify(state.quickBuyItem))
    },

    setCartItemNumber(state, { id, number }) {
      const index = lodash.findIndex(state.items, { id })
      if (index < 0) {
        return
      }

      state.items[index].number = number
      localStorage.setItem('shopping-cart', JSON.stringify(state.items))
    }

  }

}
